//import React, { Fragment } from 'react';
import React, { useState, Fragment, useContext, useEffect } from 'react';//add
import { NavLink, useLocation } from 'react-router-dom';
import { Icon } from '@material-ui/core';
import TouchRipple from '@material-ui/core/ButtonBase';
import MatxVerticalNavExpansionPanel from './MatxVerticalNavExpansionPanel';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import useSettings from 'app/hooks/useSettings';
import { AppControlContext } from 'app/contexts/AppControlContext';

import { ShopContext } from "app/contexts/ShopContext";
import ShopData from '../ShopData';
//import ShopModal from '../ShopModal';
import { ShopErrorContext } from "app/contexts/ShopErrorContext";

import { useSelector, useDispatch } from 'react-redux';//add
import MultiPulldown from 'components/common/MultiPulldown/MultiPulldown';//add
//import ShopDatePicker from 'components/common/DatePicker/DatePicker';//add
import { AppSelectShopContext } from "app/contexts/AppSelectShopContext";
import { DeveloperUuidContext } from "app/contexts/DeveloperUuidContext";



import 'app/components/style_ShopModal.css';//店舗選択を促すモーダル用CSS


const useStyles = makeStyles(({ palette, ...theme }) => ({
  navItem: {
    transition: 'all 150ms ease-in',
    '&:hover': {
      backgroundColor: palette.action.hover,
    },
  },
  navItemActive: {
    //backgroundColor: palette.action.selected,
    backgroundColor: "#0622B1",
  },
  compactNavItem: {
    overflow: 'hidden',
    justifyContent: 'center !important',
    '& $itemText': {
      display: 'none',
    },
    '& $itemIcon': {
      display: 'none',
    },
  },
  itemIcon: {},
  itemText: {
    fontSize: '0.875rem',
    paddingLeft: '0.8rem',
    // color: "#e3e",//サイドバー カテゴリー文字
  },
  label: {
    color: palette.text.secondary,
  },
  bulletIcon: {
    background: palette.text.secondary,
  },
  iconBgColor: {
    //backgroundColor:'#fff'
  },
  iconColor: {
    //color: '#000'
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  modalContent: {
    zIndex: 2,
    width: '50%',
    padding: '1em',
    background: '#fff'
  }
}));

const useStyles2 = makeStyles(({ palette, ...theme }) => ({
  navItem: {
    transition: 'all 150ms ease-in',
    '&:hover': {
      //backgroundColor: '#fd9b70 !important',//下層のホバー
      background: 'rgba(253, 165, 127, .2)',//プルダウンのラベル
    },
  },
  navItemActive: {
    //backgroundColor: palette.action.selected,
    backgroundColor: "#FF4E00",//アクティブ
    '& $itemText': {
      color: '#fff !important',
    },
    '& $itemIcon': {
      color: '#fff !important',
    },
    '& $iconBgColor': {
      backgroundColor: '#fff !important'
    },
    '& $iconColor': {
      color: '#fff !important'
    },
    '&:hover': {
      background: 'rgba(253, 165, 127, .2)',//プルダウンのラベル
      '& $itemText': {
        color: '#000 !important',
      },
      '& $itemIcon': {
        color: '#000 !important',
      },
      '& $iconBgColor': {
        backgroundColor: '#000 !important'
      },
      '& $iconColor': {
        color: '#000 !important'
      },
    }
  },
  compactNavItem: {
    overflow: 'hidden',
    justifyContent: 'center !important',
    '& $itemText': {
      display: 'none',
    },
    '& $itemIcon': {
      display: 'none',
    },
  },
  itemIcon: {},
  itemText: {
    fontSize: '0.875rem',
    paddingLeft: '0.8rem',
    color: "#000000 !important",//サイドバー カテゴリー文字
  },
  label: {
    color: "#000000 !important",
  },
  bulletIcon: {
    background: palette.text.secondary,
  },
  iconBgColor: {
    backgroundColor: '#000'
  },
  iconColor: {
    color: '#000'
  },
  hidden: {
    display: 'none'
  }
}));

const MatxVerticalNav = ({ items }) => {
  const { settings, updateSettings } = useSettings();
  const { isAppControl } = useContext(AppControlContext)
  const { mode } = settings.layout1Settings.leftSidebar;
  const classes = useStyles();
  const classes2 = useStyles2();

  const { appSelectShopId, setAppSelectShopId } = useContext(AppSelectShopContext)
  const { authority, setAuthority } = useContext(DeveloperUuidContext)
  //console.log('appSelectShopId:' + appSelectShopId)


  const { shops, setShops } = useContext(ShopContext)
  if (shops?.length) {
    //console.log(shops[0].id);
    //console.log(shops[0].name);
    //console.log(shops[0].brandId);
    //console.log(shops[0].brandName);
  } else {
    var cat = localStorage.getItem("ssvShops");
    setShops(JSON.parse(cat));
  }

  //setAppSelectShopId(appSelectShopId);

  //サイドバー押下による開け閉め
  const updateSidebarMode = (sidebarSettings) => {
    if (document.body.scrollWidth < 1280) {
      let activeLayoutSettingsName = settings.activeLayout + 'Settings';
      let activeLayoutSettings = settings[activeLayoutSettingsName];

      updateSettings({
        ...settings,
        [activeLayoutSettingsName]: {
          ...activeLayoutSettings,
          leftSidebar: {
            ...activeLayoutSettings.leftSidebar,
            ...sidebarSettings,
          },
        },
      });
    }
  };

  /* add */
  //const [load, setLoad] = useState(false);
  //const [title, setTitle] = useState('');
  //const [checked, setChecked] = React.useState({ shopTypeCheck: 0, datePickerCheck: 1 });

  //const [shops, setShops] = useState([]);
  //console.log('◆shops : ' + '\n' + shops);

  const { shopList, successShopList, messageShopList } = useSelector((state) => state.shopList);
  //console.log('◆shopList : ' + '\n' + shopList);
  const _itemsShop =
    shopList?.map(data => {
      //console.log('================')
      //console.log('label: ' + data.name + ', ' + 'value: ' + data.id)
      //return { label: data.name, value: data.id }

      //console.log('================')
      //console.log('id: ' + data.id + ', ' + 'name: ' + data.name)
      //return { id: data.id, name: data.name }
      return { id: data.id, name: data.name, brandId: data.brandId, brandName: data.brandName }

      //return { id: 6, name: 'test' }

    })
  /* // */

  const location = useLocation();


  const checkEnabledShopId = (shop_id) => {
    var arr = [431, 433, 400, 495, 398, 482, 169];
    if (shop_id) {
      var idx = arr.find(num => num == shop_id);
      //console.log('checkEnabledShopId', checkEnabledShopId);
      return (idx) ? true : false;
    } else {
      return false;
    }
  }


  const renderLevels = (data) => {
    return data.map((item, index) => {

      if (item.type === 'label')//サイドバーのラベル
        return (
          <p
            key={index}
            className={clsx({
              'px-4 mb-2 mt-6 uppercase text-12 sidenavHoverShow': true,
              [classes.label]: true,
              hidden: mode === 'compact',
            })}
          >
            {item.label}
          </p>
        );
      if (item.children) {//サイドバーの大カテゴリ

        // 権限でメニューの出し分け ////////////////////////////
        //console.log('item.children', item.children, authority);
        var _children = item.children.filter(itm => itm.authority >= authority)

        return (
          <MatxVerticalNavExpansionPanel mode={mode} item={item} key={index}>
            {renderLevels(_children)}
          </MatxVerticalNavExpansionPanel>
        );
      } else if (item.type === 'extLink') {


        return (
          <a
            key={index}
            href={item.path}
            // サイドバーのアイテムheight
            className={clsx({
              'flex justify-between h-36 border-radius-4 mb-2 compactNavItem whitespace-pre overflow-hidden': true,
              [classes.navItem]: true,
              [classes.compactNavItem]: mode === 'compact',
            })}
            rel="noopener noreferrer"
            target="_blank"
          >
            <TouchRipple key={item.name} name="child" className="w-full">
              {(() => {
                if (item.icon) {
                  return <Icon className="text-18 align-middle px-4">{item.icon}</Icon>;
                } else {
                  return <span className="item-icon icon-text">{item.iconText}</span>;
                }
              })()}
              <span className={clsx('align-middle sidenavHoverShow', !isAppControl ? classes.itemText : classes2.itemText)}>{item.name}</span>
              <div className="mx-auto"></div>
              {item.badge && <div className={`rounded bg-${item.badge.color} px-1 py-1px`}>{item.badge.value}</div>}
            </TouchRipple>
          </a>
        );
      } else if (item.type === 'storebusinesshours') {
        return (
          <NavLink
            key={index}
            to={item.path}
            activeClassName={!isAppControl ? classes.navItemActive : classes2.navItemActive}
            onClick={() => updateSidebarMode({ mode: 'close' })}
            className={
              clsx(
                (appSelectShopId == '' || appSelectShopId == undefined) ? classes2.hidden : 'flex justify-between h-36 border-radius-4 mb-2 compactNavItem whitespace-pre overflow-hidden h-hover'
              )
            }
          >
            <TouchRipple key={item.name} name="child" className="w-full">
              {item?.icon ? (
                <Icon className={clsx({ "text-18 align-middle w-36 px-4": true, }, !isAppControl ? classes.iconColor : classes2.iconColor)} color={!isAppControl ? '#fff' : "primary"}>{item.icon}</Icon>
              ) : (
                <Fragment>
                  <div
                    className={clsx({
                      'nav-bullet p-2px rounded ml-6 mr-2': true,
                      [classes.bulletIcon]: true,
                      hidden: mode === 'compact',
                    }, !isAppControl ? classes.iconBgColor : classes2.iconBgColor)}
                  ></div>
                  <div
                    className={clsx({
                      'nav-bullet-text ml-5 text-11': true,
                      hidden: mode !== 'compact',
                    })}
                  >
                    {item.iconText}
                  </div>
                </Fragment>
              )}
              <span className={clsx('align-middle text-left sidenavHoverShow', !isAppControl ? classes.itemText : classes2.itemText)}>{item.name}</span>
              <div className="mx-auto"></div>
              {item.badge && (
                <div
                  className={clsx(`rounded bg-${item.badge.color} px-1 py-1px`, 'sidenavHoverShow', classes.itemIcon)}
                >
                  {item.badge.value}
                </div>
              )}
            </TouchRipple>
          </NavLink>

        );
      } else {//サイドバーの各アイテム

        //console.log('item.name', shops[0]?.id, '[' + item.name + ']', item.name == 'メニュー種別登録 ');

        if (shops && !checkEnabledShopId(shops[0]?.id) && item.name == 'メニュー種別登録 ') {
          return null
        }

        return (
          //
          <NavLink
            key={index}
            to={item.path}
            activeClassName={!isAppControl ? classes.navItemActive : classes2.navItemActive}
            onClick={() => updateSidebarMode({ mode: 'close' })}
            className={clsx({
              'flex justify-between h-36 border-radius-4 mb-2 compactNavItem whitespace-pre overflow-hidden': true,
              [classes.navItem]: !isAppControl ? true : false,
              [classes2.navItem]: !isAppControl ? false : true,
              [classes.compactNavItem]: mode === 'compact'
            },
              location.pathname == '/salesdaily' && item.name == '期間売上' ||
                location.pathname == '/tradingdaily' && item.name == '取引履歴（電子ジャーナル）' ||
                location.pathname == '/dailydetail' && item.name == '日次・月次締め' ||
                location.pathname == '/voiddaily' && item.name == 'VOID処理' ||
                location.pathname == '/countproductoverviewdailydetail' && item.name == 'カウント商品出数' ? 'sideActive' : '',

              location.pathname == '/categoryeatinregister' && item.name == 'カテゴリ登録 ' ||
                location.pathname == '/categoryeatincsvregister' && item.name == 'カテゴリ登録 ' ||
                location.pathname == '/toppingeatinregister' && item.name == 'トッピング登録 ' ||
                location.pathname == '/toppingeatincsvregister' && item.name == 'トッピング登録 ' ||
                location.pathname == '/producteatinregister' && item.name == '商品登録 ' ||
                location.pathname == '/producteatincsvregister' && item.name == '商品登録 ' ||

                //全店舗共通（storeId=9999）
                location.pathname == '/categoryeatinallregister' && item.name == 'カテゴリ登録    ' ||
                location.pathname == '/categoryeatinallcsvregister' && item.name == 'カテゴリ登録    ' ||
                location.pathname == '/toppingeatinallregister' && item.name == 'トッピング登録    ' ||
                location.pathname == '/toppingeatinallcsvregister' && item.name == 'トッピング登録    ' ||
                location.pathname == '/producteatinallregister' && item.name == '商品登録    ' ||
                location.pathname == '/producteatinallcsvregister' && item.name == '商品登録    ' ||

                location.pathname == '/categorytakeoutallregister' && item.name == 'カテゴリ登録     ' ||
                location.pathname == '/categorytakeoutallcsvregister' && item.name == 'カテゴリ登録     ' ||
                location.pathname == '/toppingtakeoutallregister' && item.name == 'トッピング登録     ' ||
                location.pathname == '/toppingtakeoutallcsvregister' && item.name == 'トッピング登録     ' ||
                location.pathname == '/producttakeoutallregister' && item.name == '商品登録     ' ||
                location.pathname == '/producttakeoutallcsvregister' && item.name == '商品登録     ' ||

                location.pathname == '/categorydeliveryallregister' && item.name == 'カテゴリ登録      ' ||
                location.pathname == '/categorydeliveryallcsvregister' && item.name == 'カテゴリ登録      ' ||
                location.pathname == '/toppingdeliveryallregister' && item.name == 'トッピング登録      ' ||
                location.pathname == '/toppingdeliveryallcsvregister' && item.name == 'トッピング登録      ' ||
                location.pathname == '/productdeliveryallregister' && item.name == '商品登録      ' ||
                location.pathname == '/productdeliveryallcsvregister' && item.name == '商品登録      ' ||

                location.pathname == '/categorytakeoutregister' && item.name == 'カテゴリ登録  ' ||
                location.pathname == '/categorytakeoutcsvregister' && item.name == 'カテゴリ登録  ' ||
                location.pathname == '/toppingtakeoutregister' && item.name == 'トッピング登録  ' ||
                location.pathname == '/toppingtakeoutcsvregister' && item.name == 'トッピング登録  ' ||
                location.pathname == '/producttakeoutregister' && item.name == '商品登録  ' ||
                location.pathname == '/producttakeoutcsvregister' && item.name == '商品登録  ' ||

                location.pathname == '/categorydeliveryregister' && item.name == 'カテゴリ登録   ' ||
                location.pathname == '/categorydeliverycsvregister' && item.name == 'カテゴリ登録   ' ||
                location.pathname == '/toppingdeliveryregister' && item.name == 'トッピング登録   ' ||
                location.pathname == '/toppingdeliverycsvregister' && item.name == 'トッピング登録   ' ||
                location.pathname == '/productdeliveryregister' && item.name == '商品登録   ' ||
                location.pathname == '/productdeliverycsvregister' && item.name == '商品登録   ' ||

                location.pathname == '/CouponCreate' && item.name == '新規クーポン登録' ||
                location.pathname == '/CouponEdit' && item.name == 'クーポン編集・削除' ||

                location.pathname == '/PushNotificationCreate' && item.name == 'プッシュ情報通知' ||
                location.pathname == '/PushNotificationEdit' && item.name == 'プッシュ情報編集・削除' ||

                location.pathname == '/AllPushNotificationCreate' && item.name == 'プッシュ情報通知' ||
                location.pathname == '/AllPushNotificationEdit' && item.name == 'プッシュ情報編集・削除' ||

                location.pathname == '/AllCouponCreate' && item.name == '新規クーポン登録' ||
                location.pathname == '/AllCouponEdit' && item.name == 'クーポン編集・削除' ||

                location.pathname == '/TableOrder' && item.name == 'TTO・広告画像・映像登録' ||
                location.pathname == '/HiddenMenu' && item.name == '商品登録（隠しメニュー）' ||
                location.pathname == '/HiddenMenuRegister' && item.name == '商品登録（隠しメニュー）' ||
                location.pathname == '/HiddenMenuCsvRegister' && item.name == '商品登録（隠しメニュー）'
                ? classes2.navItemActive : ''
            )
            }
          >
            <TouchRipple key={item.name} name="child" className="w-full">
              {item?.icon ? (
                <Icon className={clsx({ "text-18 align-middle w-36 px-4": true, }, !isAppControl ? classes.iconColor : classes2.iconColor)} color={!isAppControl ? '#fff' : "primary"}>{item.icon}</Icon>
              ) : (
                <Fragment>

                  <div
                    className={clsx({
                      'nav-bullet p-2px rounded ml-6 mr-2': true,
                      [classes.bulletIcon]: true,
                      hidden: mode === 'compact',
                    }, !isAppControl ? classes.iconBgColor : classes2.iconBgColor)}
                  ></div>
                  <div
                    className={clsx({
                      'nav-bullet-text ml-5 text-11': true,
                      hidden: mode !== 'compact',
                    })}
                  >
                    {item.iconText}
                  </div>
                </Fragment>
              )}
              <span className={clsx('align-middle text-left sidenavHoverShow', !isAppControl ? classes.itemText : classes2.itemText)}>{item.name}</span>
              <div className="mx-auto"></div>
              {item.badge && (
                <div
                  className={clsx(`rounded bg-${item.badge.color} px-1 py-1px`, 'sidenavHoverShow', classes.itemIcon)}
                >
                  {item.badge.value}
                </div>
              )}
            </TouchRipple>
          </NavLink >
        );
      }
    });
  };



  //店舗選択のコンテキスト取る
  const shopsContext = useContext(ShopContext)
  //console.log('★ほげほげNavi1')

  const [show, setShow] = useState(false);
  //const [showFlag, setShowFlag] = useState(true);
  let shopListArray = new Array();

  const { shopError, setShopError } = useContext(ShopErrorContext);
  //console.log('shopErrorContext : ' + JSON.stringify(shopErrorContext))


  useEffect(() => {
    //console.log('★ほげほげNavi2 : ' + shopError)
    const shopActiveList = Object.values(shopsContext.shops);
    shopActiveList.map(item => {
      //console.log(item.value)//shop id
      shopListArray.push(item.value)
    })
    //店舗選択がなければモーダル表示
    if (!shopListArray?.length && shopError) {
      //console.log('hoge1')
      setShow(true);

    } else {
      //console.log('hoge2')
      setShow(false);
      //setShowFlag(true)
    }

  }, [shopError]);


  const closeModal = () => {
    console.log('close')
    setShow(false)
    setShopError(false)
  }

  function ShopModal({ show, setShow }) {
    if (show) {
      return (
        <div id="overlay" onClick={closeModal}>
          <div id="modalContent" onClick={(e) => e.stopPropagation()}>
            店舗を選択してください。
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  //return <div className="navigation">{renderLevels(items)}</div>;
  return (
    <>
      {/*{!isAppControl ?
        <ShopModal show={show} setShow={setShow} />
        : null
      }*/}
      <div className="navigation">
        {!isAppControl ?
          <div className="flexDiv">
            <div className="label">店舗選択</div>
            {/*<MultiPulldown label="" items={_itemsShop} props={shops} setProps={setShops} />*/}
            <MultiPulldown label="" items={_itemsShop} />
            {/*<ShopData shops={shops} />*/}
          </div>
          : null
        }
        {renderLevels(items)}
        {/*<ShopModal show={show} setShow={setShow} />*/}
      </div>
    </>

  );
};

export default React.memo(MatxVerticalNav);
